export const VALUATIONS_QUERY_KEY = 'valuations';
export const VALUATION_INPUTS_QUERY_KEY = 'valuation-inputs';
export const VALUATION_PERSON_INPUTS_QUERY_KEY = 'person-inputs';
export const VALUATION_BREAKPOINT_SUMMARY_QUERY_KEY = 'valuation-breakpoint-summary';
export const VALUATION_COMPUTE_START_QUERY_KEY = 'valuation-compute-start';
export const VALUATION_COMPUTE_QUERY_KEY = 'valuation-compute';
export const VALUATION_COMPUTE_PROGRESS_QUERY_KEY = 'valuation-compute-progress';
export const VALUATION_SUMMARY_RESULT_QUERY_KEY = 'valuation-summary-result';
export const VALUATION_SAVE_MUTATION_KEY = 'valuation-save';
